import { render } from "./InsuranceProviderDashboard.vue?vue&type=template&id=6d8235af&scoped=true"
import script from "./InsuranceProviderDashboard.vue?vue&type=script&lang=js"
export * from "./InsuranceProviderDashboard.vue?vue&type=script&lang=js"

import "./InsuranceProviderDashboard.vue?vue&type=style&index=0&id=6d8235af&lang=css"
import "./InsuranceProviderDashboard.vue?vue&type=style&index=1&id=6d8235af&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8235af"]])

export default __exports__